import "@/App.css";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import Navbar from "@/components/pv/Navbar";
import Hero from "@/components/pv/Hero";
import StatsBand from "@/components/pv/StatsBand";
import SportsMarquee from "@/components/pv/SportsMarquee";
import WhyPlayVerse from "@/components/pv/WhyPlayVerse";
import Glance from "@/components/pv/Glance";
import Contact from "@/components/pv/Contact";
import Footer from "@/components/pv/Footer";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.08, duration: 1.4 }}>
      <div className="App bg-[#05050A] text-white min-h-screen antialiased">
        <Navbar />
        <main>
          <Hero />
          <StatsBand />
          <SportsMarquee />
          <WhyPlayVerse />
          <Glance />
          <Contact />
        </main>
        <Footer />
        <Toaster position="bottom-right" theme="dark" richColors />
      </div>
    </ReactLenis>
  );
}

export default App;
